import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    acceptCustomerAgreementAndPrivacyPolicy,
    acceptMarketingOffers,
} from '@sxm-de/dev-kits/web-sdk/domains/agreements';

interface AcceptAgreementsForIdentityCreateFnPayload {
    language: string;
    consentToMarket: boolean;
    marketingConsentVersion: string;
    privacyAgreementVersion: string;
}

export type AcceptAgreementsForIdentityCreateFn = (
    payload: AcceptAgreementsForIdentityCreateFnPayload,
) => Promise<unknown>;

export function initAcceptAgreementsForIdentityCreateFn({
    dependencies,
    countryCodeDefault,
}: DomainInitPayload): AcceptAgreementsForIdentityCreateFn {
    return async ({
        language,
        consentToMarket,
        marketingConsentVersion,
        privacyAgreementVersion,
    }: AcceptAgreementsForIdentityCreateFnPayload) => {
        if (consentToMarket) {
            try {
                await acceptMarketingOffers(
                    {
                        version: marketingConsentVersion,
                        language: language,
                        countryCode: countryCodeDefault.toUpperCase(),
                    },
                    dependencies,
                );
            } catch {
                // Requirement is to not stop the flow if any error.
            }
        }
        try {
            await acceptCustomerAgreementAndPrivacyPolicy(
                {
                    version: privacyAgreementVersion,
                    language: language,
                    countryCode: countryCodeDefault.toUpperCase(),
                },
                dependencies,
            );
        } catch {
            // Requirement is to not stop the flow if any error.
        }
    };
}
